var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncentives(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.09 75.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c5dbfd;\n      }\n\n      .cls-2 {\n        fill: #f2f7fe;\n      }\n\n      .cls-3 {\n        fill: #2578f6;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.55,
    cy: 37.63,
    r: 29.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.55,67.13c-16.27,0-29.5-13.23-29.5-29.5s13.23-29.5,29.5-29.5,29.5,13.23,29.5,29.5-13.23,29.5-29.5,29.5ZM36.55,9.63c-15.44,0-28,12.56-28,28s12.56,28,28,28,28-12.56,28-28-12.56-28-28-28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    className: "cls-3",
    d: "M32.8,30.93l-.67,3.9c-.05.31.15.6.46.65.12.02.25,0,.36-.06l3.5-1.84,3.5,1.84c.28.15.62.04.76-.23.06-.11.08-.24.06-.37l-.67-3.9,2.83-2.76c.22-.22.23-.57.01-.8,0,0,0,0,0,0-.09-.09-.2-.15-.32-.16l-3.91-.57-1.75-3.54c-.14-.28-.48-.39-.76-.25-.11.05-.2.14-.25.25l-1.75,3.55-3.91.57c-.31.04-.52.33-.48.64.02.12.08.24.17.32l2.83,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    className: "cls-3",
    d: "M36.45,35.71h0c.31,0,.56.25.56.56v1.35c0,.31-.25.56-.56.57-.31,0-.57-.25-.57-.57h0v-1.35c0-.31.25-.56.56-.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    className: "cls-3",
    d: "M42.35,31.43c-.1.3.07.61.36.71h0s1.29.42,1.29.42c.29.11.62-.04.73-.33.11-.29-.04-.62-.33-.73l-.05-.02-1.29-.42c-.3-.1-.61.06-.71.36,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    className: "cls-3",
    d: "M40.1,24.5c.25.18.6.13.79-.12h0l.8-1.1c.18-.25.13-.6-.12-.79,0,0,0,0,0,0h0c-.25-.18-.6-.13-.79.12,0,0,0,0,0,0h0l-.8,1.1c-.18.25-.13.61.12.79,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    className: "cls-3",
    d: "M32.02,24.37c.18.25.54.31.79.13,0,0,0,0,0,0h0c.25-.18.31-.54.13-.79,0,0,0,0,0,0h0l-.8-1.1c-.18-.25-.54-.31-.79-.13,0,0,0,0,0,0h0c-.25.18-.31.53-.13.79,0,0,0,0,0,0h0l.8,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    className: "cls-3",
    d: "M28.91,32.56l1.29-.42c.3-.1.46-.42.36-.71s-.42-.46-.71-.36l-1.29.42c-.3.1-.46.42-.36.71.09.28.38.44.66.37l.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    className: "cls-3",
    d: "M43.48,39.52l-4.75,2.74,2.08.76,4.99-2.88c-.47-.81-1.5-1.09-2.31-.62,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    className: "cls-3",
    d: "M43,44.75c.03.07.05.15.07.22l5.36-3.09c.08-.04.17-.08.25-.11v-.02c-.48-.81-1.51-1.09-2.32-.62,0,0,0,0,0,0h0l-4.3,2.49c.41.29.74.69.94,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    className: "cls-3",
    d: "M51.35,43.56c-.42-.83-1.44-1.17-2.27-.75-.03.01-.05.03-.08.04l-5.79,3.34c-.03.27-.1.54-.2.79-.62,1.4-2.23,2.06-3.65,1.52l-5.42-1.98c-.3-.09-.46-.41-.37-.71.09-.3.41-.46.71-.37.01,0,.03.01.04.02l5.42,1.98c.86.33,1.84-.06,2.23-.9.37-.86-.03-1.86-.89-2.22,0,0,0,0,0,0l-.09-.03-4.42-1.61c-.58-.23-1.11-.58-1.54-1.03-1.05-1.04-2.47-1.63-3.94-1.63-1.38,0-2.74.36-3.93,1.05l-5.28,3.05c-.27.16-.36.5-.21.77,0,0,0,0,0,0l4.45,7.71c.16.27.5.36.77.21,0,0,0,0,0,0l3.68-2.12,6.31,1.61c1.14.29,2.35.12,3.37-.47l10.37-5.99c.81-.45,1.13-1.44.75-2.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentives);
export default __webpack_public_path__ + "static/media/Incentives.2e071d9ea67b651e01da3ae8641d408e.svg";
export { ForwardRef as ReactComponent };